import { logWrapper } from '../../utils';
import moment from 'moment';

export default {
  myDeadLinesController: [
    'runtimeConstant',
    '$scope',
    '$rootScope',
    'revisionService',
    '$filter',
    '$state',
    '$controller',
    'EQuickAccessItems',
    'EDocumentStatus',
    'EXT_ICONS',
    '$sce',
    'authService',
    function (
      runtimeConstant,
      $scope,
      $rootScope,
      revisionService,
      $filter,
      $state,
      $controller,
      EQuickAccessItems,
      EDocumentStatus,
      EXT_ICONS,
      $sce,
      authService
    ) {
      'use strict';

      function sortOperation(a, b, column) {
        var res = 0;
        switch (column.type) {
          case 'text':
            res = sortText(a, b, column);
            break;
          case 'number':
            res = sortNumber(a, b, column);
            break;
          case 'date':
            res = sortDate(a, b, column);
            break;
        }
        if (column.sorted === 'desc') return res * -1;

        return res;
      }

      function sortText(a, b, column) {
        if (column.sortExpression !== undefined) {
          var sort1 = $filter('reflect')(a, column.sortExpression);
          var sort2 = $filter('reflect')(b, column.sortExpression);

          if (sort1 === undefined) sort1 = '';
          if (sort2 === undefined) sort2 = '';
          return sort1.toString().localeCompare(sort2);
        } else {
          var value1 = $filter('reflect')(a, column.expression);
          var value2 = $filter('reflect')(b, column.expression);

          if (value1 === undefined) value1 = '';
          if (value2 === undefined) value2 = '';
          return value1.toString().localeCompare(value2);
        }
      }

      function sortNumber(a, b, column) {
        return column.sortExpression !== undefined
          ? $filter('reflect')(a, column.sortExpression) -
              $filter('reflect')(b, column.sortExpression)
          : $filter('reflect')(a, column.expression) -
              $filter('reflect')(b, column.expression);
      }

      function sortDate(a, b, column) {
        var firstDate, secDate;

        if (column.sortExpression !== undefined) {
          firstDate = $filter('reflect')(a, column.sortExpression);
          secDate = $filter('reflect')(b, column.sortExpression);
        } else {
          firstDate = $filter('reflect')(a, column.expression);
          secDate = $filter('reflect')(b, column.expression);
        }
        var firstSplit = firstDate.split('/');
        var secSplit = secDate.split('/');
        firstDate = Date.parse(
          firstSplit[2] + '-' + firstSplit[1] + '-' + firstSplit[0]
        );
        secDate = Date.parse(
          secSplit[2] + '-' + secSplit[1] + '-' + secSplit[0]
        );
        if (firstDate > secDate) return 1;
        if (firstDate < secDate) return -1;
      }

      function goToPage(page) {
        $state.go('home.myDeadLines', { page: page });
      }

      function selectedDeadLineTypes(value) {
        if (arguments.length === 0) return $scope.selectedDeadLineType;
        $scope.selectedDeadLineType = value;
      }

      function PreLoadExpiredPeriods() {
        var filter = {};
        $scope.myDeadLines = [];
        $scope.myWorkflowDeadLines = [];
        filter.NoDate = true;

        filter.currentPage = $state.params.page
          ? parseInt($state.params.page)
          : 1;

        filter.pageSize = 100;

        if ($scope.selectedDeadLineType.Id === 1) {
          filter.FilterAllType = 1;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 3) {
          filter.FilterDocVenc = 3;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 5) {
          filter.FilterActVenc = 5;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 2) {
          filter.FilterAllType = -1;
          filter.IsExpiryDate = false;
        } else if ($scope.selectedDeadLineType.Id === 4) {
          filter.FilterDocToVenc = 4;
          filter.IsExpiryDate = false;
        } else if ($scope.selectedDeadLineType.Id === 6) {
          filter.FilterActToVenc = 6;
          filter.IsExpiryDate = false;
        }

        $scope.Filter = filter;

        revisionService
          .loadRevisionsMyActivityExpired(
            $scope.Filter,
            $scope.currentPage,
            $scope.pageSize
          )
          .then(function (data) {
            data.forEach(function (doc) {
              doc.Title = $scope.formatedTitle(doc.Title);
              doc.ActivityName = doc.ActivityName;
              $scope.rowGuid = doc.RowGuid;

              doc.Duration = doc.Duration;
              var iniDate = new Date(doc.StartDate);
              doc.nextExpired = iniDate.setDate(
                iniDate.getDate() + doc.Duration
              );
              doc.NextExpired = $scope.formatedDate(iniDate);

              if (new Date() > iniDate) {
                if (doc.NextExpired === $scope.formatedDate(new Date())) {
                  doc.QtdVenc = 'Venceu hoje';
                  doc.DescStatus = 'Vencido';
                  doc.QtdToVenc = '---';
                } else {
                  doc.QtdVenc = $scope.countDaysVencAct(
                    doc.Duration,
                    doc.StartDate
                  );
                  doc.DescStatus = 'Vencido';
                  doc.QtdToVenc = '---';
                }
              } else {
                doc.QtdToVenc = $scope.countDaysToVencAct(
                  doc.Duration,
                  doc.StartDate
                );
                doc.QtdVenc = '---';
                doc.DescStatus = 'A vencer';
              }

              if (
                $scope.Filter.FilterDocVenc !== 3 &&
                $scope.Filter.FilterDocToVenc !== 4
              ) {
                $scope.myWorkflowDeadLines.push(doc);
              }
            });

            revisionService
              .loadRevisionsMyDocsExpired(
                $scope.Filter,
                $scope.currentPage,
                $scope.pageSize
              )
              .then(function (data) {
                data.forEach(function (doc) {
                  doc.Extension = $scope.getIcon(doc.extension);
                  doc.Title = $scope.formatedTitle(doc.title);
                  doc.AuthorName = doc.author.Name;
                  doc.DocType = $scope.formatedDocumentType(
                    doc.documentType.Name
                  );
                  doc.NextRevisionDate = $scope.formatedDate(
                    doc.nextRevisionDate
                  );

                  if (new Date() > doc.nextRevisionDate) {
                    doc.QtdVenc = $scope.countDaysVenc(
                      doc.nextRevisionDate,
                      doc.date
                    );
                    doc.DescStatus = 'Vencido';
                    doc.QtdToVenc = '---';
                  } else {
                    doc.QtdToVenc = $scope.countDaysToVenc(
                      doc.nextRevisionDate,
                      doc.date
                    );
                    doc.QtdVenc = '---';
                    doc.DescStatus = 'A vencer';
                  }
                  $scope.myDeadLines.push(doc);
                });

                $scope.count = $scope.myDeadLines.length;
                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  authService.getUserAsync().then(user => {
                    user.userPreferences.IdLastFolder = EQuickAccessItems.MYDEADLINES;
                  });
                }

                $scope.documents(data);

                $scope.groups = [];
                $scope.title = $filter('translate')('MY DEADLINES');
              });
          });
      }

      function search() {
        var filter = {};
        $scope.myDeadLines = [];
        $scope.myWorkflowDeadLines = [];
        filter.NoDate = true;

        filter.currentPage = $state.params.page
          ? parseInt($state.params.page)
          : 1;
        filter.pageSize = 100;

        if ($scope.selectedDeadLineType.Id === 1) {
          filter.FilterAllType = 1;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 3) {
          filter.FilterDocVenc = 3;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 5) {
          filter.FilterActVenc = 5;
          filter.IsExpiryDate = true;
        } else if ($scope.selectedDeadLineType.Id === 2) {
          filter.FilterAllType = -1;
          filter.IsExpiryDate = false;
        } else if ($scope.selectedDeadLineType.Id === 4) {
          filter.FilterDocToVenc = 4;
          filter.IsExpiryDate = false;
        } else if ($scope.selectedDeadLineType.Id === 6) {
          filter.FilterActToVenc = 6;
          filter.IsExpiryDate = false;
        }

        $scope.startDate = $scope.newForm.startDate.$modelValue;
        $scope.endDate = $scope.newForm.endDate.$modelValue;

        filter.StartDate = $scope.startDate =
          $scope.newForm.startDate.$modelValue;
        filter.EndDate = $scope.endDate = $scope.newForm.endDate.$modelValue;

        if (($scope.startDate !== null && $scope.startDate !== undefined) ||
					($scope.endDate !== null && $scope.endDate !== undefined)) {
          	filter.NoDate = false;
        }

        $scope.Filter = filter;

        revisionService
          .loadRevisionsMyActivityExpired(
            $scope.Filter,
            $scope.currentPage,
            $scope.pageSize
          )
          .then(function (data) {
            data.forEach(function (doc) {
              doc.Title = $scope.formatedTitle(doc.Title);
              doc.ActivityName = doc.ActivityName;
              doc.RowGuid = doc.RowGuid;

              doc.Duration = doc.Duration;
              var iniDate = new Date(doc.StartDate);
              doc.nextExpired = iniDate.setDate(
                iniDate.getDate() + doc.Duration
              );
              doc.NextExpired = $scope.formatedDate(iniDate);

              if (new Date() > iniDate) {
                if (doc.NextExpired === $scope.formatedDate(new Date())) {
                  doc.QtdVenc = 'Venceu hoje';
                  doc.DescStatus = 'Vencido';
                  doc.QtdToVenc = '---';
                } else {
                  doc.QtdVenc = $scope.countDaysVencAct(
                    doc.Duration,
                    doc.StartDate
                  );
                  doc.DescStatus = 'Vencido';
                  doc.QtdToVenc = '---';
                }
              } else {
                doc.QtdToVenc = $scope.countDaysToVencAct(
                  doc.Duration,
                  doc.StartDate
                );
                doc.QtdVenc = '---';
                doc.DescStatus = 'A vencer';
              }

              $scope.roadToFlow = () => {
                var linkActive =
                  window.location.origin + '/#/workflow/run/' + doc.RowGuid;
                window.open(linkActive);
              };

              if (
                $scope.Filter.FilterDocVenc !== 3 &&
                $scope.Filter.FilterDocToVenc !== 4
              ) {
                $scope.myWorkflowDeadLines.push(doc);
              }
            });

            $scope.count = $scope.myWorkflowDeadLines.length;
            $scope.totalItem = $scope.count;

            if ($scope.totalItem > $scope.limite) {
              $scope.limiteValorAct = $scope.limite;
              $scope.botaoAtivo = true; //Mostra o botão caso necessario
            } else {
              $scope.limiteValorAct = $scope.totalItem;
              $scope.botaoAtivo = false;
            }

            $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

            if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
              $scope.goToPage($scope.pageCount);
            } else {
              authService.getUserAsync().then(user => {
                user.userPreferences.IdLastFolder = EQuickAccessItems.MYDEADLINES;
              });
            }

            $scope.documents(data);
            $scope.groups = [];
            $scope.title = $filter('translate')('MY DEADLINES');

            revisionService
              .loadRevisionsMyDocsExpired(
                $scope.Filter,
                $scope.currentPage,
                $scope.pageSize
              )
              .then(function (data) {
                data.forEach(function (doc) {
                  doc.Folder = doc.folder.Name;
                  doc.Extension = $scope.getIcon(doc.extension);
                  doc.Title = $scope.formatedTitle(doc.title);
                  doc.AuthorName = doc.author.Name;
                  doc.DocType = $scope.formatedDocumentType(
                    doc.documentType.Name
                  );
                  doc.NextRevisionDate = $scope.formatedDate(
                    doc.nextRevisionDate
                  );
                  if (new Date() > doc.nextRevisionDate) {
                    doc.QtdVenc = $scope.countDaysVenc(
                      doc.nextRevisionDate,
                      doc.date
                    );
                    doc.DescStatus = 'Vencido';
                    doc.QtdToVenc = '---';
                  } else {
                    doc.QtdToVenc = $scope.countDaysToVenc(
                      doc.nextRevisionDate,
                      doc.date
                    );
                    doc.QtdVenc = '---';
                    doc.DescStatus = 'A vencer';
                  }
                  $scope.myDeadLines.push(doc);
                });

                $scope.count = $scope.myDeadLines.length;
                $scope.totalItem = $scope.count;

                if ($scope.totalItem > $scope.limite) {
                  $scope.limiteValor = $scope.limite;
                  $scope.botaoAtivo = true; //Mostra o botão caso necessario
                } else {
                  $scope.limiteValor = $scope.totalItem;
                  $scope.botaoAtivo = false;
                }

                $scope.pageCount = Math.ceil($scope.count / $scope.pageSize);

                if ($scope.pageCount < $scope.currentPage && $scope.count > 0) {
                  $scope.goToPage($scope.pageCount);
                } else {
                  authService.getUserAsync().then(user => {
                    user.userPreferences.IdLastFolder = EQuickAccessItems.MYDEADLINES;
                  });
                }

                $scope.documents(data);
                $scope.subTotal = $scope.totalItem + $scope.totalItem;
                $scope.groups = [];
                $scope.title = $filter('translate')('MY DEADLINES');
              });
          });
      }

      function countDaysVencAct(duration, data2) {
        var dateNow = new Date();

        var CalcDaysRunning = moment(dateNow, 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );
        var daysRunning = moment.duration(CalcDaysRunning).asDays().toFixed(0);
        var expiredPeriod = daysRunning - duration;

        return expiredPeriod + ' dias';
      }

      function countDaysToVencAct(duration, data2) {
        var dateNow = new Date();
        var CalcDaysRunning = moment(dateNow, 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );
        var daysRunning = moment.duration(CalcDaysRunning).asDays().toFixed(0);

        var RemainingDays = duration - daysRunning;
        var dateLimit = RemainingDays;

        return dateLimit + ' dias';
      }

      function countDaysToVenc(data1, data2) {
        var dateNow = new Date();
        var CalcDaysValid = moment(new Date(data1), 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );

        var CalcDaysRunning = moment(dateNow, 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );

        var daysValid = moment.duration(CalcDaysValid).asDays().toFixed(0);
        var daysRunning = moment.duration(CalcDaysRunning).asDays().toFixed(0);

        var result = daysValid - daysRunning;
        return result + ' dias';
      }

      function countDaysVenc(data1, data2) {
        var dateNow = new Date();
        var CalcDaysValid = moment(new Date(data1), 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );

        var CalcDaysRunning = moment(dateNow, 'DD/MM/YYYY HH:mm:ss').diff(
          moment(new Date(data2), 'DD/MM/YYYY HH:mm:ss')
        );

        var daysValid = moment.duration(CalcDaysValid).asDays().toFixed(0);
        var daysRunning = moment.duration(CalcDaysRunning).asDays().toFixed(0);

        var testeVenc = daysRunning - daysValid;
        return testeVenc + ' dias';
      }

      function formatedDate(date) {
        if (date === undefined) return '-';
        //if (!date.contains('T')) return date
        var result = new Date(Date.parse(date));
        return result.format('dd/mm/yyyy');
      }

      function formatedDocumentType(name) {
        return $filter('truncate')(name, 30, '...', true);
      }

      function formatedTitle(title) {
        return $scope.truncateText(title, 40);
      }

      function truncateText(string, targetCharacterLength) {
        //preciso calcular o tamanho que as tags bold estao ocupando para ficar tudo com tamanho padrao
        targetCharacterLength +=
          (string.substr(0, 60).split('<b>').length - 1) * 3;
        targetCharacterLength +=
          (string.substr(0, 60).split('</b>').length - 1) * 3;

        var length = string.length;
        if (length < targetCharacterLength) {
          return string;
        } else {
          var shortenedString = string.slice(0, targetCharacterLength);
          var tempshortenedString = shortenedString.slice(
            0,
            shortenedString.lastIndexOf(' ')
          );

          var lastMarkupBegin = -1;
          var lastMarkupEnds = -1;
          try {
            lastMarkupBegin = tempshortenedString.lastIndexOf('<b>');
            lastMarkupEnds = tempshortenedString.lastIndexOf('<');
          } catch {}

          if (lastMarkupBegin !== -1 && lastMarkupEnds === -1) {
            // has an opening anchor tag
            // not having an closing tag
            tempshortenedString = tempshortenedString.slice(0, lastMarkupBegin);
            return tempshortenedString + '... ';
          }

          var idx = shortenedString.lastIndexOf('<');
          var endTag = shortenedString.length - 4;
          if (idx >= endTag) {
            //aqui removemos o final da string caso ela tenha a abertura de alguma tag html
            shortenedString = shortenedString.substr(0, idx);
          }
          //se foi diminuido o tamanho da string comparado a original, então vou colocar tres pontos indicando que o titulo tem mais conteudo
          return shortenedString.length >= length - 4
            ? shortenedString
            : shortenedString + '... ';
        }
      }

      function sortColumnDoc(column) {
        if (column.sortable !== true) return;
        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';

        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };

        $scope.myDeadLines = $scope.myDeadLines.sort(sort);
        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function sortColumnAct(column) {
        if (column.sortable !== true) return;
        column.sorted = column.sorted === 'asc' ? 'desc' : 'asc';
        var sort = function (a, b) {
          return sortOperation(a, b, column);
        };

        $scope.myWorkflowDeadLines = $scope.myWorkflowDeadLines.sort(sort);

        var unsorted = $scope.columns.filter(function (c) {
          return c.id !== column.id;
        });

        unsorted.forEach(function (c) {
          c.sorted = undefined;
        });
      }

      function getIcon(extension) {
        var ext = extension;

        if (ext.toLowerCase().endsWith('p7s')) {
          var splited = ext.split('.');
          ext = splited[0];
        }

        var image =
          '<img src="/assets/images/file_extensions/default.png"></img>';
        if (ext !== null && EXT_ICONS.indexOf(ext.toLowerCase()) >= 0) {
          var pngAdjust = ext === 'png' ? 'style="padding-bottom:1px"' : '';
          image =
            '<img src="/assets/images/file_extensions/' +
            ext +
            '.png" onerror="this.src=\'/assets/images/file_extensions/default.png\';" width="18px" ' +
            pngAdjust +
            '></img>';
        }

        if (this.isSigned) {
          image +=
            '<img class="signed_doc" src="/assets/images/document_status/seal.png" width="10px"></img>';
        }

        if (this.hasLinkedDocuments === true) {
          image +=
            '<img class="linked_doc" src="/assets/images/document_status/linked.png" width="10px"></img>';
        }

        return $sce.trustAsHtml(image); //Show default icon when the extension icon not exists;
      }

      function loadType() {
        $scope.deadLineTypes = [];

        var data = [
          {
            Id: 1,
            Name: 'Todos os vencidos',
          },
          {
            Id: 2,
            Name: 'Todos a vencer',
          },
          {
            Id: 3,
            Name: 'Documentos vencidos',
          },
          {
            Id: 4,
            Name: 'Documentos a vencer',
          },
          {
            Id: 5,
            Name: 'Atividades vencidas',
          },
          {
            Id: 6,
            Name: 'Atividades a vencer',
          },
        ];

        $scope.deadLineTypes = data;
        $scope.deadLineTypes.push($scope.selectedDeadLineTypes);
      }

      function run() {
        try {
          $controller('baseController', { $scope: $scope });
          $controller('chatbotController', { $scope: $scope });

          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.title = $filter('translate')('MY DEADLINES');
          $scope.description = '';
          $scope.noDocuments = $filter('translate')('NO DEADLINES');
          $scope.noDocumentsMessage = $filter('translate')('NO DEADLINES MSG');

          if (!$state.params.page) {
            $state.go('home.myDeadLines', { page: 1 });
          }

          $scope.itemsFilter = function (item) {
            return item.idStatus !== EDocumentStatus.TRASH_CAN;
          };

          $scope.pageCount = 1;
          $scope.myDeadLines = [];
          $scope.myWorkflowDeadLines = [];
          $scope.columns = [];
          $scope.groups = [];
          $scope.startDate;
          $scope.endDate;
          $scope.deadLineType;
          $scope.deadLineTypes;
          $scope.selectedDeadLineType = { Id: 1, Name: 'Todos os vencidos' };

          $scope.goToPage = logWrapper(
            goToPage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectedDeadLineTypes = logWrapper(
            selectedDeadLineTypes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.PreLoadExpiredPeriods = logWrapper(
            PreLoadExpiredPeriods,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.search = logWrapper(
            search,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.countDaysVencAct = logWrapper(
            countDaysVencAct,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.countDaysToVencAct = logWrapper(
            countDaysToVencAct,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.countDaysToVenc = logWrapper(
            countDaysToVenc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.countDaysVenc = logWrapper(
            countDaysVenc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDate = logWrapper(
            formatedDate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedDocumentType = logWrapper(
            formatedDocumentType,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.formatedTitle = logWrapper(
            formatedTitle,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.truncateText = logWrapper(
            truncateText,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumnDoc = logWrapper(
            sortColumnDoc,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.sortColumnAct = logWrapper(
            sortColumnAct,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.getIcon = logWrapper(
            getIcon,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.loadType = logWrapper(
            loadType,
            runtimeConstant.isDebugControllersInternals
          );

          $scope.loadType();
          $rootScope.$broadcast('clearSearchTerm');
          $scope.autologincolumns = ['icon', 'title', 'description'];
          $scope.imageTypes = ['png', 'gif', 'jpeg', 'jpg', 'bmp'];

          $scope.columns = [
            {
              id: 'icon',
              width: '6%',
              header: $filter('translate')('COLUMN.ICON'),
              style: {
                padding: '10px 10px 10px 26px',
                'text-overflow': 'clip',
                'max-width': '50px',
              },
              expression: 'id',
              sortExpression: 'id',
              hideHeader: true,
              visible: true,
              disabled: false,
              dataPriority: 1,
            },
            {
              id: 'title',
              width: '26%',
              header: $filter('translate')('COLUMN.TITLE'),
              style: {
                'min-width': '150px',
              },

              expression: 'Title',
              sortExpression: 'Title',
              dataPriority: 2,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'descStatus',
              width: '11%',
              header: 'Status',
              style: {
                'min-width': '150px',

                'text-align': 'left',
              },

              expression: 'DescStatus',
              sortExpression: 'DescStatus',
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'folder',
              width: '10%',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'goToFolder()',
              sortExpression: 'Folder',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 4,
              sortable: true,
              disabled: false,
              type: 'text',
            },

            {
              id: 'document type',
              width: '11%',
              header: $filter('translate')('COLUMN.DOCTYPE'),
              expression: 'formatedDocumentType()',
              sortExpression: 'documentType.Name',
              style: {
                'min-width': '130px',
                'text-align': 'left',
              },
              dataPriority: 5,
              mobileShow: false,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              width: '12%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              style: {
                'min-width': '80px',
                'text-align': 'left',
              },
              expression: 'AuthorName',
              sortExpression: 'AuthorName',
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'NextRevisionDate',
              width: '12%',
              header: 'Data Venc',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'NextRevisionDate',
              mobileShow: false,
              visible: true,
              dataPriority: 7,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysVenc',
              width: '16%',
              header: 'Tempo vencido',
              style: {
                'min-width': '100px',
                'text-align': 'center',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 1,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysToVenc',
              width: '13%',
              header: 'Vence em',
              style: {
                'min-width': '100px',
                'text-align': 'center',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdToVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 1,
              disabled: false,
              sortable: true,
              type: 'date',
            },
          ];

          $scope.workflowColumns = $scope.columns = [
            {
              id: 'icon',
              width: '6%',
              header: $filter('translate')('COLUMN.ICON'),
              style: {
                padding: '10px 10px 10px 26px',
                'text-overflow': 'clip',
                'max-width': '50px',
              },
              expression: 'id',
              sortExpression: 'id',
              hideHeader: true,
              visible: true,
              disabled: false,
              dataPriority: 1,
            },
            {
              id: 'title',
              width: '26%',
              header: $filter('translate')('COLUMN.TITLE'),
              style: {
                'min-width': '150px',
              },

              expression: 'Title',
              sortExpression: 'Title',
              dataPriority: 2,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'descStatus',
              width: '11%',
              header: 'Status',
              style: {
                'min-width': '150px',
              },

              expression: 'DescStatus',
              sortExpression: 'DescStatus',
              dataPriority: 3,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'folder',
              width: '10%',
              header: $filter('translate')('COLUMN.FOLDER'),
              expression: 'goToFolder()',
              sortExpression: 'Folder',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 4,
              sortable: true,
              disabled: false,
              type: 'text',
            },

            {
              id: 'document type',
              width: '18%',
              header: $filter('translate')('COLUMN.DOCTYPE'),
              expression: 'formatedDocumentType()',
              sortExpression: 'documentType.Name',
              style: {
                'min-width': '130px',
              },
              dataPriority: 5,
              mobileShow: false,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'author',
              width: '12%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              style: {
                'min-width': '80px',
              },
              expression: 'AuthorName',
              sortExpression: 'AuthorName',
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'NextRevisionDate',
              width: '13%',
              header: 'Data Venc',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'NextRevisionDate',
              mobileShow: false,
              visible: true,
              dataPriority: 7,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysVenc',
              width: '17%',
              header: 'Tempo vencido',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 1,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysToVenc',
              width: '13%',
              header: 'Vence em',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdToVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 1,
              disabled: false,
              sortable: true,
              type: 'date',
            },
          ];

          $scope.workflowColumns = [
            {
              id: 'title',
              width: '26%',
              header: $filter('translate')('COLUMN.TITLE'),
              style: {
                'min-width': '150px',
              },

              expression: 'Title',
              sortExpression: 'Title',
              dataPriority: 1,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'descStatus',
              width: '11%',
              header: 'Status',
              style: {
                'min-width': '150px',
              },

              expression: 'DescStatus',
              sortExpression: 'DescStatus',
              dataPriority: 2,
              visible: true,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'activityName',
              width: '12%',
              header: 'Tarefa',
              style: {
                'min-width': '80px',
              },
              expression: 'ActivityName',
              sortExpression: 'ActivityName',
              mobileShow: false,
              visible: true,
              dataPriority: 3,
              disabled: false,
              sortable: true,
              type: 'text',
            },

            {
              id: 'author',
              width: '15%',
              header: $filter('translate')('COLUMN.AUTHOR'),
              expression: 'AuthorName',
              style: {
                'min-width': '80px',
              },
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'text',
            },
            {
              id: 'NextRevisionDate',
              width: '12%',
              header: 'Data Venc',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextExpired',
              expression: 'NextExpired',
              mobileShow: false,
              visible: true,
              dataPriority: 4,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysVenc',
              width: '16%',
              header: 'Tempo vencido',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 5,
              disabled: false,
              sortable: true,
              type: 'date',
            },
            {
              id: 'QtdDaysToVenc',
              width: '13%',
              header: 'Vence em',
              style: {
                'min-width': '100px',
              },
              sortExpression: 'NextRevisionDate',
              expression: 'QtdToVenc',
              mobileShow: false,
              visible: true,
              dataPriority: 6,
              disabled: false,
              sortable: true,
              type: 'date',
            },
          ];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
